import { lazy } from 'react';
const DeclarationRoutes = [
    {
        label: '',
        key: 'MainLayout',
        path: '/archives/:any',
        redirect: 'records',
        element: lazy(() => import('@/components/Layout/CommonLayout')),
        children: [
            {
                label: '申报记录',
                key: 'records',
                path: 'records',
                show: true,
                element: lazy(() => import('@/page/Declaration/Records'))
            },
            {
                label: '学时学分档案详情',
                key: 'creditHourRecord',
                path: 'creditHourRecord/:id',
                show: true,
                element: lazy(() => import('@/page/MySpace/StudyArchives/components/recordDetail/RecordDetail'))

            }
        ]
    }
];
export default DeclarationRoutes;
